import { render, staticRenderFns } from "./LabSelection.vue?vue&type=template&id=00501a3b&scoped=true"
import script from "./LabSelection.vue?vue&type=script&lang=js"
export * from "./LabSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00501a3b",
  null
  
)

export default component.exports